import { useQuery } from "@tanstack/react-query";
import { jeopardyReminderApi } from "../api/jeopardy";

export const useFetchReminder = (jeopardyId: string | undefined) => {

    const { data, isLoading, isSuccess, isRefetching, isError, error, refetch } = useQuery({
        queryKey: ["reminder-list", jeopardyId],
        queryFn: () => jeopardyReminderApi.fetchReminders(jeopardyId),
        enabled: !!jeopardyId,
    });

    return { data: isSuccess ? data.data.rows : [], isLoading: isLoading || isRefetching, isError, error, refetch };

};

export const useAdd = () => {
    const mutationFn = (payload: { "jeopardy_id": string; "reminder_title": string; "reminder_date": string; }) => jeopardyReminderApi.createReminder(payload);
    return mutationFn;
};

export const useUpdate = () => {
    const mutationFn = (payload: { "reminder_id": string; "reminder_title": string; "reminder_date": string; "is_completed": boolean; }) => jeopardyReminderApi.updateReminder({
        reminderId: payload.reminder_id,
        payload: {
            jeopardy_id: payload.reminder_id,
            reminder_title: payload.reminder_title,
            reminder_date: payload.reminder_date,
            is_completed: payload.is_completed,
        }
    });
    return mutationFn;
};